import React from 'react';
import { IonIcon, IonSpinner } from '@ionic/react';
import { arrowBack, saveOutline } from 'ionicons/icons';

/* ─── Page wrapper ─── */
export const FormPage: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="form-page">{children}</div>
);

/* ─── Top bar ─── */
export const FormTopbar: React.FC<{
  title: string;
  icon: string;
  onBack: () => void;
  onSave: () => void;
  saving?: boolean;
  disabled?: boolean;
}> = ({ title, icon, onBack, onSave, saving, disabled }) => (
  <div className="form-topbar">
    <button className="form-topbar__back" onClick={onBack}>
      <IonIcon icon={arrowBack} /> Înapoi
    </button>
    <div className="form-topbar__title">
      <IonIcon icon={icon} />
      <span>{title}</span>
    </div>
    <button className="form-topbar__save" onClick={onSave} disabled={disabled || saving}>
      {saving
        ? <IonSpinner name="crescent" style={{ width: 18, height: 18 }} />
        : <IonIcon icon={saveOutline} />}
      <span>Salvează</span>
    </button>
  </div>
);

/* ─── Submit row ─── */
export const FormSubmitRow: React.FC<{
  onCancel: () => void;
  submitLabel: string;
  saving?: boolean;
  disabled?: boolean;
}> = ({ onCancel, submitLabel, saving, disabled }) => (
  <div className="form-submit-row">
    <button type="button" className="form-btn form-btn--secondary" onClick={onCancel}>
      Anulează
    </button>
    <button type="submit" className="form-btn form-btn--primary" disabled={disabled || saving}>
      {saving && <IonSpinner name="crescent" style={{ width: 16, height: 16, marginRight: 6 }} />}
      {submitLabel}
    </button>
  </div>
);

/* ─── Info banner ─── */
export const FormBanner: React.FC<{
  icon: string;
  title: string;
  subtitle?: string;
  variant?: 'info' | 'warning';
}> = ({ icon, title, subtitle, variant = 'info' }) => (
  <div className={`form-banner form-banner--${variant}`}>
    <IonIcon icon={icon} />
    <div>
      <strong>{title}</strong>
      {subtitle && <span>{subtitle}</span>}
    </div>
  </div>
);

/* ─── Grid helpers ─── */
export const FormGrid: React.FC<{
  cols?: 2 | 3 | 6;
  children: React.ReactNode;
  style?: React.CSSProperties;
}> = ({ cols = 3, children, style }) => (
  <div className={`form-grid form-grid--${cols}`} style={style}>{children}</div>
);

/* ─── Inline info card ─── */
export const FormInlineCard: React.FC<{
  note?: string;
  icon?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}> = ({ note, icon, children, style }) => (
  <div className="form-inline-card" style={style}>
    {note && (
      <span className="form-inline-card__note">
        {icon && <IonIcon icon={icon} />} {note}
      </span>
    )}
    {children}
  </div>
);

/* ─── Empty state ─── */
export const FormEmpty: React.FC<{
  icon: string;
  message: string;
}> = ({ icon, message }) => (
  <div className="form-empty">
    <IonIcon icon={icon} />
    <span>{message}</span>
  </div>
);
